export const FILTER_ROW_OPTIONS = {
  // default, if haven't select column yet
  NOTSELECTED: [],
  STRING: [
    {
      label: 'String',
      options: [
        {
          label: 'is',
          value: 'is'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'does not contain',
          value: 'does not contain'
        },
        {
          label: 'is empty',
          value: 'is empty'
        },
        {
          label: 'is not empty',
          value: 'is not empty'
        },
        {
          label: 'in',
          value: 'in'
        },
        {
          label: 'not in',
          value: 'not in'
        },
        {
          label: 'starts with',
          value: 'starts with'
        },
        {
          label: 'does not start with',
          value: 'does not start with'
        },
        {
          label: 'ends with',
          value: 'ends with'
        },
        {
          label: 'does not end with',
          value: 'does not end with'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  NUMBER: [
    {
      label: 'Number',
      options: [
        {
          label: 'less than (<)',
          value: 'less than'
        },
        {
          label: 'equals or less than (<=)',
          value: 'equals or less than'
        },
        {
          label: 'equals (=)',
          value: 'equals'
        },
        {
          label: 'not equal to (≠)',
          value: 'not equal to'
        },
        {
          label: 'equals or greater than (>=)',
          value: 'equals or greater than'
        },
        {
          label: 'greater than (>)',
          value: 'greater than'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  BOOLEAN: [
    {
      label: 'Boolean',
      options: [
        {
          label: 'is TRUE',
          value: 'is true'
        },
        {
          label: 'is FALSE',
          value: 'is false'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  DATETIME: [
    {
      label: 'Datetime',
      options: [
        {
          label: 'before (<)',
          value: 'datetime before'
        },
        {
          label: 'is or before (<=)',
          value: 'datetime is or before'
        },
        {
          label: 'is (=)',
          value: 'datetime is'
        },
        {
          label: 'is or after (>=)',
          value: 'datetime is or after'
        },
        {
          label: 'after (>)',
          value: 'datetime after'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  DATE: [
    {
      label: 'Date',
      options: [
        {
          label: 'before (<)',
          value: 'date before'
        },
        {
          label: 'is or before (<=)',
          value: 'date is or before'
        },
        {
          label: 'is (=)',
          value: 'date is'
        },
        {
          label: 'is or after (>=)',
          value: 'date is or after'
        },
        {
          label: 'after (>)',
          value: 'date after'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  TIME: [
    {
      label: 'Time',
      options: [
        {
          label: 'before (<)',
          value: 'time before'
        },
        {
          label: 'is or before (<=)',
          value: 'time is or before'
        },
        {
          label: 'is (=)',
          value: 'time is'
        },
        {
          label: 'is or after (>=)',
          value: 'time is or after'
        },
        {
          label: 'after (>)',
          value: 'time after'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ],
  TIMESTAMP: [
    {
      label: 'Timestamp',
      options: [
        {
          label: 'before (<)',
          value: 'timestamp before'
        },
        {
          label: 'is or before (<=)',
          value: 'timestamp is or before'
        },
        {
          label: 'is (=)',
          value: 'timestamp is'
        },
        {
          label: 'is or after (>=)',
          value: 'timestamp is or after'
        },
        {
          label: 'after (>)',
          value: 'timestamp after'
        },
        {
          label: 'contains',
          value: 'contains'
        },
        {
          label: 'is null',
          value: 'is null'
        },
        {
          label: 'is not null',
          value: 'is not null'
        }
      ]
    }
  ]
};

export const DISABLE_VALUE_INPUT = ['is empty', 'is not empty', 'is null', 'is not null', 'is true', 'is false'];

export const RESERVED_KEYWORDS = [
  'ALL',
  'AND',
  'ANY',
  'ARRAY',
  'AS',
  'ASC',
  'ASSERT_ROWS_MODIFIED',
  'AT',
  'BETWEEN',
  'BY',
  'CASE',
  'CAST',
  'COLLATE',
  'CONTAINS',
  'CREATE',
  'CROSS',
  'CUBE',
  'CURRENT',
  'DEFAULT',
  'DEFINE',
  'DESC',
  'DISTINCT',
  'ELSE',
  'END',
  'ENUM',
  'ESCAPE',
  'EXCEPT',
  'EXCLUDE',
  'EXISTS',
  'EXTRACT',
  'FALSE',
  'FETCH',
  'FOLLOWING',
  'FOR',
  'FROM',
  'FULL',
  'GROUP',
  'GROUPING',
  'GROUPS',
  'HASH',
  'HAVING',
  'IF',
  'IGNORE',
  'IN',
  'INNER',
  'INTERSECT',
  'INTERVAL',
  'INTO',
  'IS',
  'JOIN',
  'LATERAL',
  'LEFT',
  'LIKE',
  'LIMIT',
  'LOOKUP',
  'MERGE',
  'NATURAL',
  'NEW',
  'NO',
  'NOT',
  'NULL',
  'NULLS',
  'OF',
  'ON',
  'OR',
  'ORDER',
  'OUTER',
  'OVER',
  'PARTITION',
  'PRECEDING',
  'PROTO',
  'RANGE',
  'RECURSIVE',
  'RESPECT',
  'RIGHT',
  'ROLLUP',
  'ROWS',
  'SELECT',
  'SET',
  'SOME',
  'STRUCT',
  'TABLESAMPLE',
  'THEN',
  'TO',
  'TREAT',
  'TRUE',
  'UNBOUNDED',
  'UNION',
  'UNNEST',
  'USING',
  'WHEN',
  'WHERE',
  'WINDOW',
  'WITH',
  'WITHIN'
];

export const FORMULA_KEYWORDS = [
  // mathematical functions
  'abs',
  'sign',
  'is_inf',
  'is_nan',
  'ieee_divide',
  'rand',
  'sqrt',
  'pow',
  'power',
  'exp',
  'ln',
  'log',
  'log10',
  'greatest',
  'least',
  'div',
  'save_divide',
  'save_multiply',
  'save_negate',
  'save_add',
  'save_substract',
  'mod',
  'round',
  'trunc',
  'ceil',
  'ceiling',
  'floor',
  'cos',
  'cosh',
  'acos',
  'acosh',
  'sin',
  'sinh',
  'asin',
  'asinh',
  'tan',
  'tanh',
  'atan',
  'atanh',
  'atan2',
  'range_bucket',
  // -------------------
  // string functions
  'ascii',
  'byte_length',
  'char_length',
  'character_length',
  'chr',
  'code_points_to_bytes',
  'code_points_to_string',
  'concat',
  'ends_with',
  'format',
  'from_base32',
  'from_base64',
  'from_hex',
  'initcap',
  'instr',
  'left',
  'length',
  'lpad',
  'lower',
  'ltrim',
  'normalize',
  'normalize_and_casefold',
  'octet_length',
  'regexp_contains',
  'regexp_extract',
  'regexp_extract_all',
  'regexp_instr',
  'regexp_replace',
  'regexp_substr',
  'replace',
  'repeat',
  'reverse',
  'right',
  'rpad',
  'rtrim',
  'safe_convert_bytes_to_string',
  'soundex',
  'split',
  'starts_with',
  'strpos',
  'substr',
  'substring',
  'to_base32',
  'to_base64',
  'to_code_points',
  'to_hex',
  'translate',
  'trim',
  'unicode',
  'upper',
  // -------------------
  // date functions
  'current_date',
  'extract',
  'date',
  'date_add',
  'date_sub',
  'date_diff',
  'date_trunc',
  'date_from_unix_date',
  'format_date',
  'last_day',
  'parse_date',
  'unix_date',
  // -------------------
  // datetime functions
  'current_datetime',
  'datetime',
  'extract',
  'datetime_add',
  'datetime_sub',
  'datetime_diff',
  'datetime_trunc',
  'format_datetime',
  'last_day',
  'parse_datetime',
  // -------------------
  // time functions
  'current_time',
  'time',
  'extract',
  'time_add',
  'time_sub',
  'time_diff',
  'time_trunc',
  'format_time',
  'parse_time',
  // -------------------
  // timestamp functions
  'current_timestamp',
  'extract',
  'string',
  'timestamp',
  'timestamp_add',
  'timestamp_sub',
  'timestamp_diff',
  'timestamp_trunc',
  'format_timestamp',
  'parse_timestamp',
  'timestamp_seconds',
  'timestamp_millis',
  'timestamp_micros',
  'unix_seconds',
  'unix_millis',
  'unix_micros',
  'row_number',
  'over'
];

export const FORMULA_DOCUMENTATION_LIST = [
  {
    type: ['all', 'popular', 'string'],
    titleDisplay: 'CONCAT',
    title: 'CONCAT(string1, string2...)',
    content: 'Concatenate one or more strings into a single string.',
    example: 'CONCAT("Acho", "_", "Studio")<br />Result: Acho_Studio',
    copy: 'CONCAT(string_column1, string_column2)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'CURRENT_DATE',
    title: 'CURRENT_DATE([time_zone])',
    content: 'Return the current date. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_DATE()<br />Result: 2021-04-26',
    copy: 'CURRENT_DATE()'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'CURRENT_DATETIME',
    title: 'CURRENT_DATETIME([time_zone])',
    content: 'Return the current datetime. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_DATETIME()<br />Result: 2021-04-26T18:24:38.702355',
    copy: 'CURRENT_DATETIME()'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'CURRENT_TIMESTAMP',
    title: 'CURRENT_TIMESTAMP()',
    content: 'Return the current timestamp.',
    example: 'CURRENT_TIMESTAMP()<br />Result: 2021-04-26 18:23:58.422989 UTC',
    copy: 'CURRENT_TIMESTAMP()'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'CURRENT_TIME',
    title: 'CURRENT_TIME([timezone])',
    content:
      'Return the current time as a time variable. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_TIME()<br />Result: 18:23:04.347264',
    copy: 'CURRENT_TIME()'
  },
  {
    type: ['all', 'date', 'type conversion'],
    titleDisplay: 'DATE',
    title: 'Date(date_expression)',
    content:
      'Convert a string, timestamp, or datetime expression to a date variable in a "yyyy-mm-dd" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'DATE("2016-12-25")<br />Result: 2016-12-25',
    copy: 'DATE(expression)'
  },
  {
    type: ['all', 'datetime', 'type conversion'],
    titleDisplay: 'DATETIME',
    title: 'DATETIME(datetime_expression)',
    content:
      'Convert a string, timestamp, or date expression to a datetime variable in a "yyyy-mm-dd hh-mm-ss" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'DATETIME("2020-12-01 14:20:32")<br />Result: 2020-12-01T14:20:32',
    copy: 'DATETIME(expression)'
  },
  {
    type: ['all', 'timestamp/time', 'type conversion'],
    titleDisplay: 'TIMESTAMP',
    title: 'TIMESTAMP(timestamp_expression)',
    content: 'Convert a string, date, or datetime expression to a timestamp variable.',
    example: 'TIMESTAMP("2020-12-25 15:30:00 UTC")<br />Result: 2020-12-25 15:30:00 UTC',
    copy: 'TIMESTAMP(expression)'
  },
  {
    type: ['all', 'timestamp/time', 'type conversion'],
    titleDisplay: 'TIME',
    title: 'TIME(time_expression)',
    content:
      'Convert a string, timestamp, or datetime expression to a time variable in a "hh-mm-ss" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'TIME(TIMESTAMP("2020-12-25 15:30:00+08"), "America/Los_Angeles")<br />Result: 23:30:00',
    copy: 'TIME(expression)'
  },
  {
    type: ['all', 'date', 'datetime', 'timestamp/time'],
    titleDisplay: 'EXTRACT',
    title: 'EXTRACT(date_part FROM date_expression)',
    content:
      'Return date_part of the date expression as an integer. The data type of the expression can be date, datetime, timestamp, or time. To see supported date_part, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#extract" target="_blank">here</a>.',
    example: 'EXTRACT(DAY FROM DATE("2020-12-25"))<br />Result: 25',
    copy: 'EXTRACT(DAY FROM date_column)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_ADD',
    title: 'DATE_ADD(date, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given date. The date_part should be one of the following values: DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATE_ADD(DATE("2020-12-25"), INTERVAL 5 DAY)<br />Result: 2020-12-30',
    copy: 'DATE_ADD(date_column, INTERVAL 1 DAY)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_SUB',
    title: 'DATE_SUB(date, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given date. The date_part should be one of the following values: DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATE_SUB(DATE("2020-12-25"), INTERVAL 5 DAY)<br />Result: 2020-12-20',
    copy: 'DATE_SUB(date_column, INTERVAL 1 DAY)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_ADD',
    title: 'DATETIME_ADD(datetime, INTERVAL integer datetime_part)',
    content:
      'Add a specified time interval to the given datetime. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATETIME_ADD(DATETIME("2020-12-25 15:30:00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25T15:40:00',
    copy: 'DATETIME_ADD(datetime_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_SUB',
    title: 'DATETIME_SUB(datetime, INTERVAL integer datetime_part)',
    content:
      'Subtract a specified time interval to a given datetime. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATETIME_SUB(DATETIME("2020-12-25 15:30:00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25T15:20:00',
    copy: 'DATETIME_SUB(datetime_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_ADD',
    title: 'TIMESTAMP_ADD(timestamp, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given timestamp. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, or DAY',
    example: 'TIMESTAMP_ADD(TIMESTAMP("2020-12-25 15:30:00+00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25 15:40:00 UTC',
    copy: 'TIMESTAMP_ADD(timestamp_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_SUB',
    title: 'TIMESTAMP_SUB(timestamp, INTERVAL integer date_part)',
    content:
      'Subtract a specified time interval to the given timestamp. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, or DAY',
    example: 'TIMESTAMP_SUB(TIMESTAMP("2020-12-25 15:30:00+00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25 15:20:00 UTC',
    copy: 'TIMESTAMP_SUB(timestamp_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_ADD',
    title: 'TIME_ADD(time, INTERVAL integer time_part)',
    content:
      'Add a specified time interval to the given time. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR',
    example: 'TIME_ADD(TIME("15:30:00"), INTERVAL 10 MINUTE)<br />Result: 15:40:00',
    copy: 'TIME_ADD(time_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_SUB',
    title: 'TIME_SUB(time, INTERVAL integer time_part)',
    content:
      'Subtract a specified time interval to the given time. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR.',
    example: 'TIME_SUB(TIME("15:30:00"), INTERVAL 10 MINUTE)\r<br />Result: 15:20:00',
    copy: 'TIME_SUB(time_column, INTERVAL 10 MINUTE)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'DATE_DIFF',
    title: 'DATE_DIFF(date1, date2, date_part)',
    content:
      'Return the difference between two dates (date1-date2). The difference is expressed in units of date_part. The date_part can be DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATE_DIFF(DATE("2017-10-15"), DATE("2017-10-13"), DAY)<br />Result: 2',
    copy: 'DATE_DIFF(date_column_1, date_column_2, DAY)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_DIFF',
    title: 'DATETIME_DIFF(datetime1, datetime2, date_part)',
    content:
      'Return the difference between two datetimes (dateime1-datetime2). The difference is expressed in units of date_part.  The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATETIME_DIFF(DATETIME("2020-12-25 10:20:00"), DATETIME("2020-12-20 15:30:00"), DAY)<br />Result: 5',
    copy: 'DATETIME_DIFF(datetime_column_1, datetime_column_2, DAY)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_DIFF',
    title: 'TIMESTAMP_DIFF(timestamp1, timestamp2, date_part)',
    content:
      'Return the difference between two timestamps (timestamp1-timestamp2). The difference is expressed in units of date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR or ISOYEAR.',
    example:
      'TIMESTAMP_DIFF(TIMESTAMP("2020-12-25 13:00:00+00"), TIMESTAMP("2020-12-25 15:30:00+00"), HOUR)<br />Result: -2',
    copy: 'TIMESTAMP_DIFF(timestamp_column_1, timestamp_column_2, DAY)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_DIFF',
    title: 'TIME_DIFF(time1, time2, time_part)',
    content:
      'Return the difference between two times(time1-time2). The difference is expressed in units of time_part. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, or HOUR.',
    example: 'TIME_DIFF(TIME("15:30:00"), TIME("14:35:00"), MINUTE)<br />Result: 55',
    copy: 'TIME_DIFF(time_column_1, time_column_2, MINUTE)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_TRUNC',
    title: 'DATE_TRUNC(date, date_part)',
    content:
      'Truncate a specific date to the start of a given unit of duration and returns a new date. The unit of duration is defined by date_part. <br /><br />The date_part can be DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: "DATE_TRUNC(DATE( '2021-4-23'), MONTH)<br />Result: 2021-04-01",
    copy: 'DATE_TRUNC(date_column, MONTH)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_TRUNC',
    title: 'DATETIME_TRUNC(datetime, date_part)',
    content:
      'Truncate a specific datetime to the start of a given unit of duration and returns a new datetime. The unit of duration is defined by date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATETIME_TRUNC(DATETIME("2021-04-10 15:30:00"), HOUR)<br />Result: 2021-04-10T15:00:00',
    copy: 'DATETIME_TRUNC(datetime_column, MONTH)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_TRUNC',
    title: 'TIMESTAMP_TRUNC(timestamp, date_part, [timezone])',
    content:
      'Truncate a specific timestamp to the start of a given unit of duration and returns a new timestamp. The unit of duration is defined by date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR or ISOYEAR.',
    example: 'TIMESTAMP_TRUNC(TIMESTAMP("2020-12-25 15:30:00+00"), DAY, "UTC")<br />Result:  2020-12-25 00:00:00 UTC',
    copy: 'TIMESTAMP_TRUNC(timestamp_column, MONTH)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_TRUNC',
    title: 'TIME_TRUNC(time, time_part)',
    content:
      'Truncate a specific time to the start of a given unit of duration and returns a new time. The unit of duration is defined by time_part. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR',
    example: 'TIME_TRUNC(TIME("15:30:00"), HOUR)<br />Result: 15:00:00',
    copy: 'TIMESTAMP_TRUNC(time_column, HOUR)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_FROM_UNIX_DATE',
    title: 'DATE_FROM_UNIX_DATE(integer)',
    content:
      'Transform a UNIX date expression (that is,  the number of days since 1970-01-01) into a standard date format (yyyy-mm-dd).',
    example: 'DATE_FROM_UNIX_DATE(18650)<br />Result: 2021-01-23',
    copy: 'DATE_FROM_UNIX_DATE(unix_date_column)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'FORMAT_DATE',
    title: 'FORMAT_DATE(format, date)',
    content:
      'Transform a date variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_DATE("%b-%d-%Y", DATE("2008-12-25"))<br />Result: Dec-25-2008',
    copy: 'FORMAT_DATE(format, date_column)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'FORMAT_DATETIME',
    title: 'FORMAT_DATETIME(format, datetime)',
    content:
      'Transform a datetime variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/datetime-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_DATETIME("%b %Y", DATETIME("2020-12-25 15:30:00"))<br />Result: Dec 2020',
    copy: 'FORMAT_DATETIME(format, datetime_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'FORMAT_TIMESTAMP',
    title: 'FORMAT_TIMESTAMP(format, timestamp, [timezone])',
    content:
      'Transforms a timestamp variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/timestamp-time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_TIMESTAMP("%b-%d-%Y", TIMESTAMP "2020-12-25 15:30:00+00", "UTC")<br />Result: Dec-25-2020',
    copy: 'FORMAT_TIMESTAMP(format, timestamp_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'FORMAT_TIME',
    title: 'FORMAT_TIME(format, time)',
    content:
      'Transform a time variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_TIME("%R", TIME "15:30:00")<br />Result: 15:30',
    copy: 'FORMAT_TIME(format, time_column)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'PARSE_DATE',
    title: 'PARSE_DATE(format, date)',
    content:
      'Convert a string to a date variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_DATE("%A %b %e %Y", "Thursday Feb 11 2021")<br />Result: 2021-02-11',
    copy: 'PARSE_DATE(format_string, string_column)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'PARSE_DATETIME',
    title: 'PARSE_DATETIME(format, datetime)',
    content:
      'Convert a string to a datetime variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/datetime-functions#supported-format-elements" target="_blank">here</a>.',
    example: "PARSE_DATETIME('%m/%d/%Y %I:%M:%S %p', '8/30/2020 2:23:38 PM')<br />Result:  2020-08-30T14:23:38",
    copy: 'PARSE_DATETIME(format, string_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'PARSE_TIMESTAMP',
    title: 'PARSE_TIMESTAMP(format, timestamp)',
    content:
      'Convert a string to a timestamp variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/timestamp-time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_TIMESTAMP("%a %b %e %I:%M:%S %Y", "Thu Dec 25 07:30:00 2020")<br />Result: 2020-12-25 07:30:00 UTC',
    copy: 'PARSE_TIMESTAMP(format, string_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'PARSE_TIME',
    title: 'PARSE_TIMESTAMP(format, time)',
    content:
      'Convert a string to a time variable according to the specified format. Supported format elements please see <a href="https://docs.acho.io/supported-math-functions-in-formula/time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_TIME("%I:%M:%S", "07:30:00")<br />Result: 07:30:00',
    copy: 'PARSE_TIME(format, string_column)'
  },
  {
    type: ['all', 'date', 'datetime'],
    titleDisplay: 'LAST_DAY',
    title: 'LAST_DAY(date, [date_part])',
    content:
      'Extract the last day of a given unit of duration for a given date. The unit of duration is defined by date_part. This is commonly used to return the last date of the month. The date_part can be optionally specified as YEAR, QUARTER, MONTH, WEEK, WEEK(<WEEKDAY>), ISOWEEK, or ISOYEAR.',
    example:
      "LAST_DAY(DATE('2021-03-25'), MONTH)<br />Result: 2021-03-31<br /><br />LAST_DAY(DATETIME('2021-03-25 15:30:00'), MONTH)\r<br />Result: 2021-03-31",
    copy: 'LAST_DAY(date_column, MONTH)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'UNIX_DATE',
    title: 'UNIX_DATE(date)',
    content: 'Return the number of days since 1970-01-01.',
    example: 'UNIX_DATE(DATE("2020-12-25"))<br />Result: 18621',
    copy: 'UNIX_DATE(date_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_SECONDS',
    title: 'TIMESTAMP_SECONDS(integer)',
    content:
      'Convert a UNIX timestamp in seconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of seconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_SECONDS(1600219000)<br />Result: 2020-09-16 01:16:40 UTC',
    copy: 'TIMESTAMP_SECONDS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_MILLIS',
    title: 'TIMESTAMP_MILLIS(integer)',
    content:
      'Convert a UNIX timestamp in milliseconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of milliseconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_MILLIS(1600219123456)<br />Result: 2020-09-16 01:18:43.456 UTC',
    copy: 'TIMESTAMP_MILLIS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_MICROS',
    title: 'TIMESTAMP_MICROS(integer)',
    content:
      'Convert a UNIX timestamp in microseconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of microseconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_MICROS(1600219123456789)<br />Result: 2020-09-16 01:18:43.456789 UTC',
    copy: 'TIMESTAMP_MICROS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_SECONDS',
    title: 'UNIX_SECONDS(timestamp)',
    content: 'Return the number of seconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_SECONDS(TIMESTAMP("2008-12-25 15:30:00+00"))<br />Result: 1608910200',
    copy: 'UNIX_SECONDS(timestamp)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_MILLIS',
    title: 'UNIX_MILLIS(timestamp)',
    content: 'Return the number of milliseconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_MILLIS(TIMESTAMP("2020-12-25 15:30:00+00"))<br />Result: 1608910200000',
    copy: 'UNIX_MILLIS(timestamp)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_MICROS',
    title: 'UNIX_MICROS(timestamp)',
    content: 'Return the number of microseconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_MICROS(TIMESTAMP("2008-12-25 15:30:00+00"))<br />Result: 1608910200000000',
    copy: 'UNIX_MICROS(timestamp)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'ASCII',
    title: 'ASCII(string)',
    content: 'Return the ASCII code value of the first character in a string.',
    example: "ASCII('a')<br />Result: 97<br /><br />ASCII('acho')<br />Result: 97",
    copy: 'ASCII(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'ENDS_WITH',
    title: 'ENDS_WITH(string, substring)',
    content: 'Return True if the string ends with the substring.',
    example: 'ENDS_WITH("Acho", "o")<br />Result: True<br /><br />ENDS_WITH("Apple", "o")<br />Result: False',
    copy: 'ENDS_WITH(string_column, substring)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'INITCAP',
    title: 'INITCAP(string, [delimiters])',
    content:
      'Make the first letter of each word uppercase and the rest of the letters lowercase. Words are delimited by white space or other characters that you can specify in delimiters.',
    example:
      'INITCAP("acho studio")<br />Result: "Acho Studio"<br /><br />INITCAP("ACHO_STUDIO", "_")<br />Result: "Acho_Studio"',
    copy: 'INITCAP(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'INSTR',
    title: 'INSTR(string, subsstring, [position], [occurence])',
    content:
      'Return the position of the first substring in the string. 0 is returned when no match is found. Position determines where the search starts in a string. Occurrence refers to extract the i-th occurrence (ex: 2 means second occurrence).',
    example:
      'INSTR("Acho Studio", "o"),<br />Result: 4 (the position of the first "o")<br /><br />INSTR("Acho Studio", "o", 1, 2)<br />Result: 2 (the position of the second "o" from the first character)',
    copy: 'INSTR(string_column, substring)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LEFT',
    title: 'LEFT(string, num_chars)',
    content: 'Return the specified number of characters from the start of the given string.',
    example: 'LEFT("Acho", 2)<br />Result: "Ac"',
    copy: 'LEFT(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LENGTH',
    title: 'LENGTH(string)',
    content: 'Return the length of a string in characters or bytes.',
    example: "LENGTH('acho')<br />Result: 4",
    copy: 'LENGTH(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LOWER',
    title: 'LOWER(string)',
    content: 'Convert a text string to all lowercase letters.',
    example: 'LOWER("ACHO")<br />Result: "acho"',
    copy: 'LOWER(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LTRIM',
    title: 'LTRIM(string, [substring])',
    content:
      'Remove all leading spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "Acho   "<br /><br />TRIM("###Acho#", "#")<br />Result: "Acho#"',
    copy: 'LTRIM(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_CONTAINS',
    title: 'REGEXP_CONTAINS(string, regexp)',
    content:
      'Return True if a string is a partial match for the regular expression pattern. To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_CONTAINS("contact@acho.io", r"@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+")<br />Result: true',
    copy: 'REGEXP_CONTAINS(string_column, regexp)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_EXTRACT',
    title: 'REGEXP_EXTRACT(string, regexp, position, occurence)',
    content:
      'Extract the substring of the given string that matches the regular expression pattern. Returns NULL if there is no match. Position determines where the search starts in a string. Occurrence refers to extract i-th occurrence (ex: 2 means second occurrence). To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_EXTRACT("contact@acho.io", r"^[a-zA-Z0-9_.+-]+")<br />Result: "contact"',
    copy: 'REGEXP_EXTRACT(string_column, regexp)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_REPLACE',
    title: 'REGEXP_REPLACE(string, regexp, replacement_string)',
    content:
      'Return a string where all substrings of value that match the regular expression pattern are replaced with the replacement_string. To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_REPLACE("#AchoStudio#", r"#$", "")\r<br />Result: "#AchoStudio"',
    copy: 'REGEXP_REPLACE(string_column, regexp, replacement_string)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REPLACE',
    title: 'REPLACE(original_string, from_value, to_value)',
    content:
      'Replace all occurrences of from_value with to_value in original_string. If the from_value is not found, the string is unchanged.',
    example: 'REPLACE("apple pie", "pie", "cobbler")<br />Result: "apple cobbler"',
    copy: 'REPLACE(original_string_column, from_value, to_value)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RIGHT',
    title: 'RIGHT(string, num_chars)',
    content: 'Return the specified number of characters from the end of the given string.',
    example: 'RIGHT("Acho", 2)<br />Result: "ho"',
    copy: 'RIGHT(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RTRIM',
    title: 'RTRIM(string, [substring])',
    content:
      'Remove all trailing spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "   Acho"',
    copy: 'RTRIM(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'STARTS_WITH',
    title: 'STARTS_WITH(string, substring)',
    content: 'Return True if the string ends with the substring.',
    example: 'ENDS_WITH("Acho", "A")<br />Result: True',
    copy: 'STARTS_WITH(string_column, substring)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'STRPOS',
    title: 'STRPOS(string, substring)',
    content:
      'Return the position of the substring within a specified string. If the substring occurs in several positions, it will only return the first occurrence.',
    example: "STRPOS('Acho Studio', 'o')<br />Result: 4",
    copy: 'STRPOS(string_column, substring)'
  },
  {
    type: ['all', 'popular', 'string'],
    titleDisplay: 'SUBSTR',
    title: 'SUBSTR(string, position, [length])',
    content:
      'Extract a substring from the given string, which starts at the position. The position refers to the position of a character in the given string. You can optionally specify the length to decide the number of characters that you want to extract.',
    example: 'SUBSTR("Acho Studio", 3)<br />Result: "ho Studio"<br /><br />SUBSTR("Acho Studio", 4, 5)<br />Result: "o Stu"',
    copy: 'SUBSTR(string_column, position)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'TRIM',
    title: 'TRIM(string, [substring])',
    content:
      'Remove all leading and trailing spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "Acho"',
    copy: 'TRIM(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'UPPER',
    title: 'UPPER(string)',
    content: 'Convert a text string to all uppercase letters.',
    example: 'UPPER("Acho")<br />Result: "ACHO"',
    copy: 'UPPER(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LPAD',
    title: 'LPAD(string, return_length, [pad_string])',
    content:
      'Left-pad a string with blanks to a specified length. You can optionally specify set a pad_string to replace blanks.',
    example:
      'LPAD("acho", 10)<br />Result: "      acho" (fill 6 blanks in the left side)<br /><br />LPAD("acho", 10, "1234")<br />Result: "123412acho"<br /><br />LPAD("acho", 3)\r<br />Result: "ach"',
    copy: 'LPAD(string_column, return_length, [pad_string])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RPAD',
    title: 'RPAD(string, return_length, [pad_string])',
    content:
      'Right-pad a string with blanks to a specified length. You can optionally specify set a pad_string to replace blanks.',
    example:
      'RPAD("acho", 10)<br />Result: "acho      " (fill 6 blanks in the left side)<br /><br />RPAD("acho", 10, "1234")<br />Result: "acho123412"<br /><br />RPAD("acho", 3)<br />Result: "cho"',
    copy: 'RPAD(string_column, return_length, [pad_string])'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ABS',
    title: 'ABS(number)',
    content: 'Return the absolute value of the given number.',
    example: 'ABS(25) = 25<br />ABS(-25) = 25',
    copy: 'ABS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SIGN',
    title: 'SIGN(number)',
    content: 'Return -1 for negative, 0 for zero, and +1 for positive arguments, respectively.',
    example: 'SIGN(25) = 1<br />SIGN(0) = 0<br />SIGN(-25) = -1',
    copy: 'SIGN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IS_INF',
    title: 'IS_INF(number)',
    content: 'Return TRUE if the value is positive or negative infinity.',
    example: 'IS_INF(+inf) = TRUE<br />IS_INF(-inf) = TRUE<br />IS_INF(25) = FALSE',
    copy: 'IS_INF(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IS_NAN',
    title: 'IS_NAN(number)',
    content: 'Return TRUE if the value is a NaN value.',
    example: 'IS_NAN(NaN) = TRUE<br />IS_NAN(25) = FALSE',
    copy: 'IS_NAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IEEE_DIVIDE',
    title: 'IEEE_DIVIDE(number1, number2)',
    content:
      'Divide number1 by number2 and return floats. Unlike the division operator (/), this function does not generate errors for division by zero or overflow.',
    example: 'IEEE_DIVIDE(20, 4) = 5<br />IEEE_DIVIDE(20, 0) = NaN',
    copy: 'IEEE_DIVIDE(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'RAND',
    title: 'RAND()',
    content: 'Return random numbers between 0 and 1 (inclusive of zero but exclusive of 1).',
    example: 'RAND() = 0.28263632192554994',
    copy: 'RAND()'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SQRT',
    title: 'SQRT(number)',
    content: 'Compute the square root of the number.',
    example: 'SQRT(25) = 5',
    copy: 'SQRT(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'POWER',
    title: 'POWER(number, power)',
    content: 'Return the result of a number raised to the given power.',
    example: 'POWER(5,2) = 5^2 = 25',
    copy: 'POWER(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'EXP',
    title: 'EXP(number)',
    content: 'Return e raised to the given power.',
    example: 'EXP(0) = 1',
    copy: 'EXP(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LN',
    title: 'LN(number)',
    content: 'Compute the natural logarithm of the number.',
    example: 'LN(1) = 0',
    copy: 'LN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LOG',
    title: 'LOG(number, [base])',
    content:
      'Compute the logarithm of the number for the given base. If the base value is omitted, base e is used (equivalent to LN(number)).',
    example: 'LOG(100, 10) = 2',
    copy: 'LOG(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LOG10',
    title: 'LOG10(number)',
    content: 'Compute the logarithm of the number for a base of 10.',
    example: 'LOG(100) = 2',
    copy: 'LOG10(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'GREATEST',
    title: 'GREATEST(X1,...,XN)',
    content: 'Return the largest value among X1,...,XN. If any parts of X1,...,XN are NULL, the return value is NULL.',
    example: 'GREATEST(1,2,3) = 3<br />GREATEST(1,2,NULL) = NULL',
    copy: 'GREATEST(numeric_column1, numeric_column2...)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LEAST',
    title: 'LEAST(X1,...,XN)',
    content: 'Return the smallest value among X1,...,XN. If any parts of X1,...,XN are NULL, the return value is NULL.',
    example: 'LEAST(1,2,3) = 1<br />LEAST(1,2,NULL) = NULL',
    copy: 'LEAST(numeric_column1, numeric_column2...)'
  },
  {
    type: ['all', 'integer'],
    titleDisplay: 'DIV',
    title: 'DIV(number1, number2)',
    content: 'Divide number1 by number2 and returns the integer part of the division.',
    example: 'DIV(25,4) = 6',
    copy: 'DIV(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_DIVIDE',
    title: 'SAFE_DIVIDE(number1, number2)',
    content:
      'Equivalent to the division operator (number1 / number2), but returns NULL if an error occurs, such as a division by zero error.',
    example: 'SAFE_DIVIDE(20,4) = 5<br />SAFE_DIVIDE(20,0) = NULL',
    copy: 'SAFE_DIVIDE(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_MULTIPLY',
    title: 'SAFE_MULTIPLY(number1, number2)',
    content: 'Equivalent to the multiplication operator (number1*number2), but returns NULL if overflow occurs.',
    example: 'SAFE_MULTIPLY(5,4) = 20',
    copy: 'SAFE_MULTIPLY(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_NEGATE',
    title: 'SAFE_NEGATE(number)',
    content: 'Equivalent to the unary minus operator (-), but returns NULL if overflow occurs.',
    example: 'SAFE_NEGATE(20) = -20<br />SAFE_NEGATE(-20) = 20',
    copy: 'SAFE_NEGATE(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_ADD',
    title: 'SAFE_ADD(number1, number2)',
    content: 'Equivalent to the addition operator (number1 + number2), but returns NULL if overflow occurs.',
    example: 'SAFE_ADD(5,4) = 9',
    copy: 'SAFE_ADD(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_SUBSTRACT',
    title: 'SAFE_SUBTRACT(number1, number2)',
    content: 'Equivalent to the subtraction operator (number1-number2), but returns NULL if overflow occurs.',
    example: 'SAFE_SUBTRACT(5,4) = 1',
    copy: 'SAFE_SUBSTRACT(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer'],
    titleDisplay: 'MOD',
    title: 'MOD(number1, number2)',
    content:
      'Return the remainder of the division of number1 by number2. The returned value has the same sign as number1. An error is generated if number2 is 0.',
    example: 'MOD(5,3) = 2<br />MOD(5,0) = Error',
    copy: 'MOD(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'popular', 'integer', 'float'],
    titleDisplay: 'ROUND',
    title: 'ROUND(number, n_decimals)',
    content: 'Round a number to the nearest integer value or a specified number of decimals.',
    example: 'ROUND(2.3) = 2<br />ROUND(2.8) = 3',
    copy: 'ROUND(numeric_column, n_decimals)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'TRUNC',
    title: 'TRUNC(number, [n_decimals])',
    content:
      'Round a number to the nearest integer value. The absolute value of the integer is not greater than the absolute value of the original number. You can optionally specify n_decimals to decide the number of decimals.',
    example: 'ROUND(2.8) = 2 ( |2| < |2.8|)<br />ROUND(-2.8) = -2 (|-2| < |-2.8|)',
    copy: 'TRUNC(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'CEIL',
    title: 'CEIL(number)',
    content: 'Round the number to the nearest integer value, which is not less than the original number.',
    example: 'CEIL(2.3) = 3.0 (3.0 > 2.3)<br /><br />CEIL(-5.6) = -5.0  (-5.0 > -5.6)',
    copy: 'CEIL(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'FLOOR',
    title: 'FLOOR(number)',
    content: 'Round the number to the nearest integer value, which is not greater than the original number.',
    example: 'FLOOR(2.3) = 2.0 (2.0 < 2.3)<br /><br />FLOOR(-5.6) = -6.0 (-6 < -5.6)',
    copy: 'FLOOR(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'COS',
    title: 'COS(angle)',
    content: 'Return the cosine of an angle, which is specified in radians.',
    example: 'COS(1) = 0.5403',
    copy: 'COS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ACOS',
    title: 'ACOS(number)',
    content: 'Return the arccosine of a number. The result is in radians.',
    example: 'ACOS(1) = 0',
    copy: 'ACOS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SIN',
    title: 'SIN(angle)',
    content: 'Return the sine of an angle, which is specified in radians.',
    example: 'SIN(1) = 0.8415',
    copy: 'SIN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ASIN',
    title: 'ASIN(number)',
    content: 'Return the arcsine of a number. The result is in radians.',
    example: 'ASIN(1) =1.5708',
    copy: 'ASIN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'TAN',
    title: 'TAN(numer)',
    content: 'Return the tangent of an angle, which is specified in radians.',
    example: 'TAN(1) = 1.5574',
    copy: 'TAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ATAN',
    title: 'ATAN(number)',
    content: 'Return the arctangent of a number. The result is in radians.',
    example: 'ATAN(1) = 0.7854',
    copy: 'ATAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ATAN2',
    title: 'ATAN2(y number, x number)',
    content: 'Return the arctangent of two given numbers (x and y. The result is in radians.',
    example: 'ATAN2(3,4) = 0.6435',
    copy: 'ATAN2(numeric_column)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'CASE',
    title: 'CASE \n      WHEN <condition1> THEN <return1>\n      [...]\n      [ELSE <else>] \nEND',
    content:
      'Find values that matche <condtion> and returns the corresponding <return> value. <condtion> must be a boolean expression (ex: age>20)',
    example:
      'CASE WHEN age < 20 THEN "teenager"<br />           WHEN age < 60 THEN "adult"<br />           ELSE "elder adult" <br />END',
    copy: 'CASE \n      WHEN <condition1> THEN <return1>\n       WHEN <condition2> THEN <return2>\n      [ELSE <else>] \nEND'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'IF',
    title: 'IF(condition, true_result, else_result)',
    content:
      'Check whether a value meets a condition and assign it to different values. If TRUE, it returns true_value. Otherwise, it returns else_value.',
    example: 'IF(age > 20, "adult", "nonadult")<br />IF(close_price > open_price, "higher", "lower")',
    copy: 'IF(condition, true_value, false_value)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'IFNULL',
    title: 'IFNULL(value, null_replacement)',
    content:
      'Check whether a value is NULL. If the value is not null, it returns the original value. Otherwise, it returns null_replacement.',
    example: 'IFNULL(NULL, -1) = -1<br />IFNULL(profit, 0)',
    copy: 'IFNULL(column, null_replacement)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'NULLIF',
    title: 'NULLIF(value1, value2)',
    content: 'Check whether value1 is equal to value2. Returns NULL if TRUE, otherwise returns the value1.',
    example: 'NULLIF(0, 0) = NULL<br />NULLIF(10, 0) = 10',
    copy: 'NULLIF(column, value_or_column)'
  },
  {
    type: ['all', 'popular', 'others'],
    titleDisplay: 'ROW_NUMBER',
    title: 'ROW_NUMBER() OVER([PARTITION BY column1] [ORDER BY column2])',
    content:
      'Assign a sequential integer to each row as a row number. The row number starts from 1. If <column1>  is specified, the function will group data based on column1 and assign numbers for each group separately. If <column2> is specified, the function will sort data based on the column first and then assign a row number for each row.',
    example: 'row_number = ROW_NUMBER() OVER()',
    copy: 'ROW_NUMBER() OVER()'
  },
  {
    type: ['all', 'popular', 'others'],
    titleDisplay: 'LAG',
    title: 'LAG(column1, [n_lags]) OVER([PARTITION BY column2] ORDER BY column3)',
    content:
      'Move each value in <column1> forward to the next row. The table will be ordered by <column3> first before values are moved. If n_lags is specified, each value is shifted to the next n_lags rows. The first n_lags values will be NULL. If <column2>  is specified, the function will group data based on <column2> and move values for each group separately.',
    example: 'price_lag = LAG(price) OVER(ORDER BY date)',
    copy: 'LAG(column1) OVER(ORDER BY column2)'
  },
  {
    type: ['all', 'type conversion'],
    titleDisplay: 'CAST',
    title: 'CAST(value AS typename)',
    content:
      'Convert the value to the other data type. CAST() may fail if some value cannot be converted to the specified type.<br /><br />The type name can be STRING, BOOL, FLOAT64, INT64, NUMERIC, DATE, DATETIME, TIME, TIMESTAMP.',
    example:
      'CAST(123 AS STRING)\r<br />Result: "123"\r<br />\r<br />CAST("apple" AS INT64)\r<br />Result: raising an error',
    copy: 'CAST(column AS typename)'
  },
  {
    type: ['all', 'type conversion'],
    titleDisplay: 'SAFE_CAST',
    title: 'SAFE_CAST(expression AS typename)',
    content:
      'Convert the value to the other data type. SAFE_CAST() is identical to CAST(), but it never fails. It returns NULL when facing an error. <br /><br />The type name can be STRING, BOOL, FLOAT64, INT64, NUMERIC, DATE, DATETIME, TIME, TIMESTAMP.',
    example: 'SAFE_CAST(123 AS STRING)<br />Result: "123"<br /><br />SAFE_CAST("apple" AS INT64)<br />Result: null',
    copy: 'SAFE_CAST(column AS typename)'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_TO_STRING',
    title: 'ARRAY_TO_STRING(array_column, [delimiter], [null_text])',
    content:
      'Convert the array column into the string column. The delimiter by default is a comma. If null_text is specified, all NULL values in the array will be replaced by the null_text.',
    example:
      'ARRAY_TO_STRING(["coffee", "tea", "milk"])<br />Result: "coffee, tea, milk"<br /><br />ARRAY_TO_STRING(["coffee", "tea", NULL], "--", "missing")<br />Result: "coffee--tea--missing"',
    copy: 'ARRAY_TO_STRING(array_column, [delimiter], [null_text])'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_LENGTH',
    title: 'ARRAY_LENGTH(array_column)',
    content:
      'Return the number of the elements in the array. 0 represents an empty array and NULL if the array_expression is NULL.',
    example: 'ARRAY_LENGTH(["coffee", "tea", "milk"])<br />Result: 3',
    copy: 'ARRAY_LENGTH(array_column)'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_REVERSE',
    title: 'ARRAY_REVERSE(array_column)',
    content: 'Reverse the array in reverse order.',
    example: 'ARRAY_REVERSE(["coffee", "tea", "milk"])\r<br />Result: ["milk", "tea", "coffee"]',
    copy: 'ARRAY_REVERSE(array_column)'
  }
];

export const SQL_EDITOR_DOCUMENTATION_LIST = [
  {
    type: ['all', 'popular', 'string'],
    titleDisplay: 'CONCAT',
    title: 'CONCAT(string1, string2...)',
    content: 'Concatenate one or more strings into a single string.',
    example: 'CONCAT("Acho", "_", "Studio")<br />Result: Acho_Studio',
    copy: 'CONCAT(string1, string2...)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'CURRENT_DATE',
    title: 'CURRENT_DATE([time_zone])',
    content: 'Return the current date. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_DATE()<br />Result: 2021-04-26',
    copy: 'CURRENT_DATE([time_zone])'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'CURRENT_DATETIME',
    title: 'CURRENT_DATETIME([time_zone])',
    content: 'Return the current datetime. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_DATETIME()<br />Result: 2021-04-26T18:24:38.702355',
    copy: 'CURRENT_DATETIME([time_zone])'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'CURRENT_TIMESTAMP',
    title: 'CURRENT_TIMESTAMP()',
    content: 'Return the current timestamp.',
    example: 'CURRENT_TIMESTAMP()<br />Result: 2021-04-26 18:23:58.422989 UTC',
    copy: 'CURRENT_TIMESTAMP()'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'CURRENT_TIME',
    title: 'CURRENT_TIME([timezone])',
    content:
      'Return the current time as a time variable. The default timezone is UTC. You can optionally specify a time zone.',
    example: 'CURRENT_TIME()<br />Result: 18:23:04.347264',
    copy: 'CURRENT_TIME([timezone])'
  },
  {
    type: ['all', 'date', 'type conversion'],
    titleDisplay: 'DATE',
    title: 'Date(date_expression)',
    content:
      'Convert a string, timestamp, or datetime expression to a date variable in a "yyyy-mm-dd" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'DATE("2016-12-25")<br />Result: 2016-12-25',
    copy: 'Date(date_expression)'
  },
  {
    type: ['all', 'datetime', 'type conversion'],
    titleDisplay: 'DATETIME',
    title: 'DATETIME(datetime_expression)',
    content:
      'Convert a string, timestamp, or date expression to a datetime variable in a "yyyy-mm-dd hh-mm-ss" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'DATETIME("2020-12-01 14:20:32")<br />Result: 2020-12-01T14:20:32',
    copy: 'DATETIME(datetime_expression)'
  },
  {
    type: ['all', 'timestamp/time', 'type conversion'],
    titleDisplay: 'TIMESTAMP',
    title: 'TIMESTAMP(timestamp_expression)',
    content: 'Convert a string, date, or datetime expression to a timestamp variable.',
    example: 'TIMESTAMP("2020-12-25 15:30:00 UTC")<br />Result: 2020-12-25 15:30:00 UTC',
    copy: 'TIMESTAMP(timestamp_expression)'
  },
  {
    type: ['all', 'timestamp/time', 'type conversion'],
    titleDisplay: 'TIME',
    title: 'TIME(time_expression)',
    content:
      'Convert a string, timestamp, or datetime expression to a time variable in a "hh-mm-ss" format. For the timestamp inputs, you can optionally specify a time zone.',
    example: 'TIME(TIMESTAMP("2020-12-25 15:30:00+08"), "America/Los_Angeles")<br />Result: 23:30:00',
    copy: 'TIME(time_expression)'
  },
  {
    type: ['all', 'date', 'datetime', 'timestamp/time'],
    titleDisplay: 'EXTRACT',
    title: 'EXTRACT(date_part FROM date_column)',
    content:
      'Return date_part of the date expression as an integer. The data type of the expression can be date, datetime, timestamp, or time. To see supported date_part, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#extract" target="_blank">here</a>.',
    example: 'EXTRACT(DAY FROM DATE("2020-12-25"))<br />Result: 25',
    copy: 'EXTRACT(date_part FROM date_column)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_ADD',
    title: 'DATE_ADD(date_column, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given date. The date_part should be one of the following values: DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATE_ADD(DATE("2020-12-25"), INTERVAL 5 DAY)<br />Result: 2020-12-30',
    copy: 'DATE_ADD(date_column, INTERVAL integer date_part)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_SUB',
    title: 'DATE_SUB(date_column, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given date. The date_part should be one of the following values: DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATE_SUB(DATE("2020-12-25"), INTERVAL 5 DAY)<br />Result: 2020-12-20',
    copy: 'DATE_SUB(date_column, INTERVAL integer date_part)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_ADD',
    title: 'DATETIME_ADD(datetime_column, INTERVAL integer datetime_part)',
    content:
      'Add a specified time interval to the given datetime. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATETIME_ADD(DATETIME("2020-12-25 15:30:00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25T15:40:00',
    copy: 'DATETIME_ADD(datetime_column, INTERVAL integer datetime_part)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_SUB',
    title: 'DATETIME_SUB(datetime_column, INTERVAL integer datetime_part)',
    content:
      'Subtract a specified time interval to a given datetime. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, QUARTER, or YEAR.',
    example: 'DATETIME_SUB(DATETIME("2020-12-25 15:30:00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25T15:20:00',
    copy: 'DATETIME_SUB(datetime_column, INTERVAL integer datetime_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_ADD',
    title: 'TIMESTAMP_ADD(timestamp_column, INTERVAL integer date_part)',
    content:
      'Add a specified time interval to the given timestamp. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, or DAY',
    example: 'TIMESTAMP_ADD(TIMESTAMP("2020-12-25 15:30:00+00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25 15:40:00 UTC',
    copy: 'TIMESTAMP_ADD(timestamp_column, INTERVAL integer date_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_SUB',
    title: 'TIMESTAMP_SUB(timestamp_column, INTERVAL integer date_part)',
    content:
      'Subtract a specified time interval to the given timestamp. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, or DAY',
    example: 'TIMESTAMP_SUB(TIMESTAMP("2020-12-25 15:30:00+00"), INTERVAL 10 MINUTE)<br />Result: 2020-12-25 15:20:00 UTC',
    copy: 'TIMESTAMP_SUB(timestamp_column, INTERVAL integer date_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_ADD',
    title: 'TIME_ADD(time_column, INTERVAL integer time_part)',
    content:
      'Add a specified time interval to the given time. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR',
    example: 'TIME_ADD(TIME("15:30:00"), INTERVAL 10 MINUTE)<br />Result: 15:40:00',
    copy: 'TIME_ADD(time_column, INTERVAL integer time_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_SUB',
    title: 'TIME_SUB(time_column, INTERVAL integer time_part)',
    content:
      'Subtract a specified time interval to the given time. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR.',
    example: 'TIME_SUB(TIME("15:30:00"), INTERVAL 10 MINUTE)\r<br />Result: 15:20:00',
    copy: 'TIME_SUB(time_column, INTERVAL integer time_part)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'DATE_DIFF',
    title: 'DATE_DIFF(date_column1, date_column2, date_part)',
    content:
      'Return the difference between two dates (date1-date2). The difference is expressed in units of date_part. The date_part can be DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATE_DIFF(DATE("2017-10-15"), DATE("2017-10-13"), DAY)<br />Result: 2',
    copy: 'DATE_DIFF(date_column1, date_column2, date_part)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_DIFF',
    title: 'DATETIME_DIFF(datetime_column1, datetime_column2, date_part)',
    content:
      'Return the difference between two datetimes (dateime1-datetime2). The difference is expressed in units of date_part.  The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATETIME_DIFF(DATETIME("2020-12-25 10:20:00"), DATETIME("2020-12-20 15:30:00"), DAY)<br />Result: 5',
    copy: 'DATETIME_DIFF(datetime_column1, datetime_column2, date_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_DIFF',
    title: 'TIMESTAMP_DIFF(timestamp_column1, timestamp_column2, date_part)',
    content:
      'Return the difference between two timestamps (timestamp1-timestamp2). The difference is expressed in units of date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK(begins on Sunday), ISOWEEK(begins on Monday), MONTH, QUARTER, YEAR or ISOYEAR.',
    example:
      'TIMESTAMP_DIFF(TIMESTAMP("2020-12-25 13:00:00+00"), TIMESTAMP("2020-12-25 15:30:00+00"), HOUR)<br />Result: -2',
    copy: 'TIMESTAMP_DIFF(timestamp_column1, timestamp_column2, date_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_DIFF',
    title: 'TIME_DIFF(time_column1, time_column2, time_part)',
    content:
      'Return the difference between two times(time1-time2). The difference is expressed in units of time_part. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, or HOUR.',
    example: 'TIME_DIFF(TIME("15:30:00"), TIME("14:35:00"), MINUTE)<br />Result: 55',
    copy: 'TIME_DIFF(time_column1, time_column2, time_part)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_TRUNC',
    title: 'DATE_TRUNC(date_column, date_part)',
    content:
      'Truncate a specific date to the start of a given unit of duration and returns a new date. The unit of duration is defined by date_part. <br /><br />The date_part can be DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: "DATE_TRUNC(DATE( '2021-4-23'), MONTH)<br />Result: 2021-04-01",
    copy: 'DATE_TRUNC(date_column, date_part)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'DATETIME_TRUNC',
    title: 'DATETIME_TRUNC(datetime_column, date_part)',
    content:
      'Truncate a specific datetime to the start of a given unit of duration and returns a new datetime. The unit of duration is defined by date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR, or ISOYEAR.',
    example: 'DATETIME_TRUNC(DATETIME("2021-04-10 15:30:00"), HOUR)<br />Result: 2021-04-10T15:00:00',
    copy: 'DATETIME_TRUNC(datetime_column, date_part)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_TRUNC',
    title: 'TIMESTAMP_TRUNC(timestamp_column, date_part, [timezone])',
    content:
      'Truncate a specific timestamp to the start of a given unit of duration and returns a new timestamp. The unit of duration is defined by date_part. The date_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR, DAY, WEEK, WEEK(<WEEKDAY>), ISOWEEK, MONTH, QUARTER, YEAR or ISOYEAR.',
    example: 'TIMESTAMP_TRUNC(TIMESTAMP("2020-12-25 15:30:00+00"), DAY, "UTC")<br />Result:  2020-12-25 00:00:00 UTC',
    copy: 'TIMESTAMP_TRUNC(timestamp_column, date_part, [timezone])'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIME_TRUNC',
    title: 'TIME_TRUNC(time_column, time_part)',
    content:
      'Truncate a specific time to the start of a given unit of duration and returns a new time. The unit of duration is defined by time_part. The time_part can be MICROSECOND, MILLISECOND, SECOND, MINUTE, HOUR',
    example: 'TIME_TRUNC(TIME("15:30:00"), HOUR)<br />Result: 15:00:00',
    copy: 'TIME_TRUNC(time_column, time_part)'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'DATE_FROM_UNIX_DATE',
    title: 'DATE_FROM_UNIX_DATE(unix_date_column)',
    content:
      'Transform a UNIX date expression (that is,  the number of days since 1970-01-01) into a standard date format (yyyy-mm-dd).',
    example: 'DATE_FROM_UNIX_DATE(18650)<br />Result: 2021-01-23',
    copy: 'DATE_FROM_UNIX_DATE(unix_date_column)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'FORMAT_DATE',
    title: 'FORMAT_DATE(format_string, date_column)',
    content:
      'Transform a date variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_DATE("%b-%d-%Y", DATE("2008-12-25"))<br />Result: Dec-25-2008',
    copy: 'FORMAT_DATE(format_string, date_column)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'FORMAT_DATETIME',
    title: 'FORMAT_DATETIME(format_string, datetime_column)',
    content:
      'Transform a datetime variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/datetime-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_DATETIME("%b %Y", DATETIME("2020-12-25 15:30:00"))<br />Result: Dec 2020',
    copy: 'FORMAT_DATETIME(format_string, datetime_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'FORMAT_TIMESTAMP',
    title: 'FORMAT_TIMESTAMP(format_string, timestamp_column, [timezone])',
    content:
      'Transforms a timestamp variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/timestamp-time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_TIMESTAMP("%b-%d-%Y", TIMESTAMP "2020-12-25 15:30:00+00", "UTC")<br />Result: Dec-25-2020',
    copy: 'FORMAT_TIMESTAMP(format_string, timestamp_column, [timezone])'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'FORMAT_TIME',
    title: 'FORMAT_TIME(format_string, time_column)',
    content:
      'Transform a time variable into a string variable in a specific format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'FORMAT_TIME("%R", TIME "15:30:00")<br />Result: 15:30',
    copy: 'FORMAT_TIME(format_string, time_column)'
  },
  {
    type: ['all', 'popular', 'date'],
    titleDisplay: 'PARSE_DATE',
    title: 'PARSE_DATE(format_string, date_column)',
    content:
      'Convert a string to a date variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/date-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_DATE("%A %b %e %Y", "Thursday Feb 11 2021")<br />Result: 2021-02-11',
    copy: 'PARSE_DATE(format_string, date_column)'
  },
  {
    type: ['all', 'datetime'],
    titleDisplay: 'PARSE_DATETIME',
    title: 'PARSE_DATETIME(format_string, datetime_column)',
    content:
      'Convert a string to a datetime variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/datetime-functions#supported-format-elements" target="_blank">here</a>.',
    example: "PARSE_DATETIME('%m/%d/%Y %I:%M:%S %p', '8/30/2020 2:23:38 PM')<br />Result:  2020-08-30T14:23:38",
    copy: 'PARSE_DATETIME(format_string, datetime_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'PARSE_TIMESTAMP',
    title: 'PARSE_TIMESTAMP(format_string, timestamp_column)',
    content:
      'Convert a string to a timestamp variable according to the specified format. To see supported format elements, visit <a href="https://docs.acho.io/supported-math-functions-in-formula/timestamp-time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_TIMESTAMP("%a %b %e %I:%M:%S %Y", "Thu Dec 25 07:30:00 2020")<br />Result: 2020-12-25 07:30:00 UTC',
    copy: 'PARSE_TIMESTAMP(format_string, timestamp_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'PARSE_TIME',
    title: 'PARSE_TIMESTAMP(format_string, time_column)',
    content:
      'Convert a string to a time variable according to the specified format. Supported format elements please see <a href="https://docs.acho.io/supported-math-functions-in-formula/time-functions#supported-format-elements" target="_blank">here</a>.',
    example: 'PARSE_TIME("%I:%M:%S", "07:30:00")<br />Result: 07:30:00',
    copy: 'PARSE_TIMESTAMP(format_string, time_column)'
  },
  {
    type: ['all', 'date', 'datetime'],
    titleDisplay: 'LAST_DAY',
    title: 'LAST_DAY(date_column, [date_part])',
    content:
      'Extract the last day of a given unit of duration for a given date. The unit of duration is defined by date_part. This is commonly used to return the last date of the month. The date_part can be optionally specified as YEAR, QUARTER, MONTH, WEEK, WEEK(<WEEKDAY>), ISOWEEK, or ISOYEAR.',
    example:
      "LAST_DAY(DATE('2021-03-25'), MONTH)<br />Result: 2021-03-31<br /><br />LAST_DAY(DATETIME('2021-03-25 15:30:00'), MONTH)\r<br />Result: 2021-03-31",
    copy: 'LAST_DAY(date_column, [date_part])'
  },
  {
    type: ['all', 'date'],
    titleDisplay: 'UNIX_DATE',
    title: 'UNIX_DATE(date_column)',
    content: 'Return the number of days since 1970-01-01.',
    example: 'UNIX_DATE(DATE("2020-12-25"))<br />Result: 18621',
    copy: 'UNIX_DATE(date_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_SECONDS',
    title: 'TIMESTAMP_SECONDS(unix_time_column)',
    content:
      'Convert a UNIX timestamp in seconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of seconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_SECONDS(1600219000)<br />Result: 2020-09-16 01:16:40 UTC',
    copy: 'TIMESTAMP_SECONDS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_MILLIS',
    title: 'TIMESTAMP_MILLIS(unix_time_column)',
    content:
      'Convert a UNIX timestamp in milliseconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of milliseconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_MILLIS(1600219123456)<br />Result: 2020-09-16 01:18:43.456 UTC',
    copy: 'TIMESTAMP_MILLIS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'TIMESTAMP_MICROS',
    title: 'TIMESTAMP_MICROS(unix_time_column)',
    content:
      'Convert a UNIX timestamp in microseconds to a timestamp in a standard format. The UNIX timestamp in seconds is expressed as the number of microseconds since 1970-01-01 00:00:00 UTC.',
    example: 'TIMESTAMP_MICROS(1600219123456789)<br />Result: 2020-09-16 01:18:43.456789 UTC',
    copy: 'TIMESTAMP_MICROS(unix_time_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_SECONDS',
    title: 'UNIX_SECONDS(timestamp_column)',
    content: 'Return the number of seconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_SECONDS(TIMESTAMP("2008-12-25 15:30:00+00"))<br />Result: 1608910200',
    copy: 'UNIX_SECONDS(timestamp_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_MILLIS',
    title: 'UNIX_MILLIS(timestamp_column)',
    content: 'Return the number of milliseconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_MILLIS(TIMESTAMP("2020-12-25 15:30:00+00"))<br />Result: 1608910200000',
    copy: 'UNIX_MILLIS(timestamp_column)'
  },
  {
    type: ['all', 'timestamp/time'],
    titleDisplay: 'UNIX_MICROS',
    title: 'UNIX_MICROS(timestamp_column)',
    content: 'Return the number of microseconds since 1970-01-01 00:00:00 UTC.',
    example: 'UNIX_MICROS(TIMESTAMP("2008-12-25 15:30:00+00"))<br />Result: 1608910200000000',
    copy: 'UNIX_MICROS(timestamp_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'ASCII',
    title: 'ASCII(string_column)',
    content: 'Return the ASCII code value of the first character in a string.',
    example: "ASCII('a')<br />Result: 97<br /><br />ASCII('acho')<br />Result: 97",
    copy: 'ASCII(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'ENDS_WITH',
    title: 'ENDS_WITH(string_column, substring)',
    content: 'Return True if the string ends with the substring.',
    example: 'ENDS_WITH("Acho", "o")<br />Result: True<br /><br />ENDS_WITH("Apple", "o")<br />Result: False',
    copy: 'ENDS_WITH(string_column, substring)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'INITCAP',
    title: 'INITCAP(string_column, [delimiters])',
    content:
      'Make the first letter of each word uppercase and the rest of the letters lowercase. Words are delimited by white space or other characters that you can specify in delimiters.',
    example:
      'INITCAP("acho studio")<br />Result: "Acho Studio"<br /><br />INITCAP("ACHO_STUDIO", "_")<br />Result: "Acho_Studio"',
    copy: 'INITCAP(string_column, [delimiters])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'INSTR',
    title: 'INSTR(string_column, substring, [position], [occurence])',
    content:
      'Return the position of the first substring in the string. 0 is returned when no match is found. Position determines where the search starts in a string. Occurrence refers to extract the i-th occurrence (ex: 2 means second occurrence).',
    example:
      'INSTR("Acho Studio", "o"),<br />Result: 4 (the position of the first "o")<br /><br />INSTR("Acho Studio", "o", 1, 2)<br />Result: 2 (the position of the second "o" from the first character)',
    copy: 'INSTR(string_column, substring, [position], [occurence])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LEFT',
    title: 'LEFT(string_column, num_chars)',
    content: 'Return the specified number of characters from the start of the given string.',
    example: 'LEFT("Acho", 2)<br />Result: "Ac"',
    copy: 'LEFT(string_column, num_chars)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LENGTH',
    title: 'LENGTH(string_column)',
    content: 'Return the length of a string in characters or bytes.',
    example: "LENGTH('acho')<br />Result: 4",
    copy: 'LENGTH(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LOWER',
    title: 'LOWER(string_column)',
    content: 'Convert a text string to all lowercase letters.',
    example: 'LOWER("ACHO")<br />Result: "acho"',
    copy: 'LOWER(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LTRIM',
    title: 'LTRIM(string_column, [substring])',
    content:
      'Remove all leading spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "Acho   "<br /><br />TRIM("###Acho#", "#")<br />Result: "Acho#"',
    copy: 'LTRIM(string_column, [substring])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_CONTAINS',
    title: 'REGEXP_CONTAINS(string_column, regexp)',
    content:
      'Return True if a string is a partial match for the regular expression pattern. To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_CONTAINS("contact@acho.io", r"@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+")<br />Result: true',
    copy: 'REGEXP_CONTAINS(string_column, regexp)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_EXTRACT',
    title: 'REGEXP_EXTRACT(string_column, regexp, position, occurence)',
    content:
      'Extract the substring of the given string that matches the regular expression pattern. Returns NULL if there is no match. Position determines where the search starts in a string. Occurrence refers to extract i-th occurrence (ex: 2 means second occurrence). To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_EXTRACT("contact@acho.io", r"^[a-zA-Z0-9_.+-]+")<br />Result: "contact"',
    copy: 'REGEXP_EXTRACT(string_column, regexp, position, occurence)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REGEXP_REPLACE',
    title: 'REGEXP_REPLACE(string_column, regexp, replacement_string)',
    content:
      'Return a string where all substrings of value that match the regular expression pattern are replaced with the replacement_string. To see supported regular expression, visit <a href="https://github.com/google/re2/wiki/Syntax" target="_blank">here</a>.',
    example: 'REGEXP_REPLACE("#AchoStudio#", r"#$", "")<br />Result: "#AchoStudio"',
    copy: 'REGEXP_REPLACE(string_column, regexp, replacement_string)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'REPLACE',
    title: 'REPLACE(string_column, from_value, to_value)',
    content:
      'Replace all occurrences of from_value with to_value in original_string. If the from_value is not found, the string is unchanged.',
    example: 'REPLACE("apple pie", "pie", "cobbler")<br />Result: "apple cobbler"',
    copy: 'REPLACE(string_column, from_value, to_value)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RIGHT',
    title: 'RIGHT(string_column, num_chars)',
    content: 'Return the specified number of characters from the end of the given string.',
    example: 'RIGHT("Acho", 2)<br />Result: "ho"',
    copy: 'RIGHT(string_column, num_chars)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RTRIM',
    title: 'RTRIM(string_column, [substring])',
    content:
      'Remove all trailing spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "   Acho"',
    copy: 'RTRIM(string_column, [substring])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'STARTS_WITH',
    title: 'STARTS_WITH(string_column, substring)',
    content: 'Return True if the string ends with the substring.',
    example: 'ENDS_WITH("Acho", "A")<br />Result: True',
    copy: 'STARTS_WITH(string_column, substring)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'STRPOS',
    title: 'STRPOS(string_column, substring)',
    content:
      'Return the position of the substring within a specified string. If the substring occurs in several positions, it will only return the first occurrence.',
    example: "STRPOS('Acho Studio', 'o')<br />Result: 4",
    copy: 'STRPOS(string_column, substring)'
  },
  {
    type: ['all', 'popular', 'string'],
    titleDisplay: 'SUBSTR',
    title: 'SUBSTR(string_column, position, [length])',
    content:
      'Extract a substring from the given string, which starts at the position. The position refers to the position of a character in the given string. You can optionally specify the length to decide the number of characters that you want to extract.',
    example: 'SUBSTR("Acho Studio", 3)<br />Result: "ho Studio"<br /><br />SUBSTR("Acho Studio", 4, 5)<br />Result: "o Stu"',
    copy: 'SUBSTR(string_column, position, [length])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'TRIM',
    title: 'TRIM(string_column, [substring])',
    content:
      'Remove all leading and trailing spaces. If you want to remove strings other than spaces, you can optionally specify a substring.',
    example: 'TRIM("   Acho   ")<br />Result: "Acho"',
    copy: 'TRIM(string_column, [substring])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'UPPER',
    title: 'UPPER(string_column)',
    content: 'Convert a text string to all uppercase letters.',
    example: 'UPPER("Acho")<br />Result: "ACHO"',
    copy: 'UPPER(string_column)'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'LPAD',
    title: 'LPAD(string_column, return_length, [pad_string])',
    content:
      'Left-pad a string with blanks to a specified length. You can optionally specify set a pad_string to replace blanks.',
    example:
      'LPAD("acho", 10)<br />Result: "      acho" (fill 6 blanks in the left side)<br /><br />LPAD("acho", 10, "1234")<br />Result: "123412acho"<br /><br />LPAD("acho", 3)\r<br />Result: "ach"',
    copy: 'LPAD(string_column, return_length, [pad_string])'
  },
  {
    type: ['all', 'string'],
    titleDisplay: 'RPAD',
    title: 'RPAD(string_column, return_length, [pad_string])',
    content:
      'Right-pad a string with blanks to a specified length. You can optionally specify set a pad_string to replace blanks.',
    example:
      'RPAD("acho", 10)<br />Result: "acho      " (fill 6 blanks in the left side)<br /><br />RPAD("acho", 10, "1234")<br />Result: "acho123412"<br /><br />RPAD("acho", 3)<br />Result: "cho"',
    copy: 'RPAD(string_column, return_length, [pad_string])'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ABS',
    title: 'ABS(numeric_column)',
    content: 'Return the absolute value of the given number.',
    example: 'ABS(25) = 25<br />ABS(-25) = 25',
    copy: 'ABS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SIGN',
    title: 'SIGN(numeric_column)',
    content: 'Return -1 for negative, 0 for zero, and +1 for positive arguments, respectively.',
    example: 'SIGN(25) = 1<br />SIGN(0) = 0<br />SIGN(-25) = -1',
    copy: 'SIGN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IS_INF',
    title: 'IS_INF(numeric_column)',
    content: 'Return TRUE if the value is positive or negative infinity.',
    example: 'IS_INF(+inf) = TRUE<br />IS_INF(-inf) = TRUE<br />IS_INF(25) = FALSE',
    copy: 'IS_INF(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IS_NAN',
    title: 'IS_NAN(numeric_column)',
    content: 'Return TRUE if the value is a NaN value.',
    example: 'IS_NAN(NaN) = TRUE<br />IS_NAN(25) = FALSE',
    copy: 'IS_NAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'IEEE_DIVIDE',
    title: 'IEEE_DIVIDE(numeric_column1, numeric_column2)',
    content:
      'Divide number1 by number2 and return floats. Unlike the division operator (/), this function does not generate errors for division by zero or overflow.',
    example: 'IEEE_DIVIDE(20, 4) = 5<br />IEEE_DIVIDE(20, 0) = NaN',
    copy: 'IEEE_DIVIDE(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'RAND',
    title: 'RAND()',
    content: 'Return random numbers between 0 and 1 (inclusive of zero but exclusive of 1).',
    example: 'RAND() = 0.28263632192554994',
    copy: 'RAND()'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SQRT',
    title: 'SQRT(numeric_column)',
    content: 'Compute the square root of the number.',
    example: 'SQRT(25) = 5',
    copy: 'SQRT(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'POWER',
    title: 'POWER(numeric_column, power)',
    content: 'Return the result of a number raised to the given power.',
    example: 'POWER(5,2) = 5^2 = 25',
    copy: 'POWER(numeric_column, power)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'EXP',
    title: 'EXP(numeric_column)',
    content: 'Return e raised to the given power.',
    example: 'EXP(0) = 1',
    copy: 'EXP(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LN',
    title: 'LN(numeric_column)',
    content: 'Compute the natural logarithm of the number.',
    example: 'LN(1) = 0',
    copy: 'LN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LOG',
    title: 'LOG(numeric_column, [base])',
    content:
      'Compute the logarithm of the number for the given base. If the base value is omitted, base e is used (equivalent to LN(number)).',
    example: 'LOG(100, 10) = 2',
    copy: 'LOG(numeric_column, [base])'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LOG10',
    title: 'LOG10(numeric_column)',
    content: 'Compute the logarithm of the number for a base of 10.',
    example: 'LOG(100) = 2',
    copy: 'LOG10(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'GREATEST',
    title: 'GREATEST(X1,...,XN)',
    content: 'Return the largest value among X1,...,XN. If any parts of X1,...,XN are NULL, the return value is NULL.',
    example: 'GREATEST(1,2,3) = 3<br />GREATEST(1,2,NULL) = NULL',
    copy: 'GREATEST(X1,...,XN)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'LEAST',
    title: 'LEAST(X1,...,XN)',
    content: 'Return the smallest value among X1,...,XN. If any parts of X1,...,XN are NULL, the return value is NULL.',
    example: 'LEAST(1,2,3) = 1<br />LEAST(1,2,NULL) = NULL',
    copy: 'LEAST(X1,...,XN)'
  },
  {
    type: ['all', 'integer'],
    titleDisplay: 'DIV',
    title: 'DIV(numeric_column1, numeric_column2)',
    content: 'Divide number1 by number2 and returns the integer part of the division.',
    example: 'DIV(25,4) = 6',
    copy: 'DIV(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_DIVIDE',
    title: 'SAFE_DIVIDE(numeric_column1, numeric_column2)',
    content:
      'Equivalent to the division operator (number1 / number2), but returns NULL if an error occurs, such as a division by zero error.',
    example: 'SAFE_DIVIDE(20,4) = 5<br />SAFE_DIVIDE(20,0) = NULL',
    copy: 'SAFE_DIVIDE(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_MULTIPLY',
    title: 'SAFE_MULTIPLY(numeric_column1, numeric_column2)',
    content: 'Equivalent to the multiplication operator (number1*number2), but returns NULL if overflow occurs.',
    example: 'SAFE_MULTIPLY(5,4) = 20',
    copy: 'SAFE_MULTIPLY(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_NEGATE',
    title: 'SAFE_NEGATE(numeric_column)',
    content: 'Equivalent to the unary minus operator (-), but returns NULL if overflow occurs.',
    example: 'SAFE_NEGATE(20) = -20<br />SAFE_NEGATE(-20) = 20',
    copy: 'SAFE_NEGATE(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_ADD',
    title: 'SAFE_ADD(numeric_column1, numeric_column2)',
    content: 'Equivalent to the addition operator (number1 + number2), but returns NULL if overflow occurs.',
    example: 'SAFE_ADD(5,4) = 9',
    copy: 'SAFE_ADD(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SAFE_SUBSTRACT',
    title: 'SAFE_SUBTRACT(numeric_column1, numeric_column2)',
    content: 'Equivalent to the subtraction operator (number1-number2), but returns NULL if overflow occurs.',
    example: 'SAFE_SUBTRACT(5,4) = 1',
    copy: 'SAFE_SUBTRACT(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'integer'],
    titleDisplay: 'MOD',
    title: 'MOD(numeric_column1, numeric_column2)',
    content:
      'Return the remainder of the division of number1 by number2. The returned value has the same sign as number1. An error is generated if number2 is 0.',
    example: 'MOD(5,3) = 2<br />MOD(5,0) = Error',
    copy: 'MOD(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'popular', 'integer', 'float'],
    titleDisplay: 'ROUND',
    title: 'ROUND(numeric_column, n_decimals)',
    content: 'Round a number to the nearest integer value or a specified number of decimals.',
    example: 'ROUND(2.3) = 2<br />ROUND(2.8) = 3',
    copy: 'ROUND(numeric_column, n_decimals)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'TRUNC',
    title: 'TRUNC(numeric_column, [n_decimals])',
    content:
      'Round a number to the nearest integer value. The absolute value of the integer is not greater than the absolute value of the original number. You can optionally specify n_decimals to decide the number of decimals.',
    example: 'ROUND(2.8) = 2 ( |2| < |2.8|)<br />ROUND(-2.8) = -2 (|-2| < |-2.8|)',
    copy: 'TRUNC(numeric_column, [n_decimals])'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'CEIL',
    title: 'CEIL(numeric_column)',
    content: 'Round the number to the nearest integer value, which is not less than the original number.',
    example: 'CEIL(2.3) = 3.0 (3.0 > 2.3)<br /><br />CEIL(-5.6) = -5.0  (-5.0 > -5.6)',
    copy: 'CEIL(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'FLOOR',
    title: 'FLOOR(numeric_column)',
    content: 'Round the number to the nearest integer value, which is not greater than the original number.',
    example: 'FLOOR(2.3) = 2.0 (2.0 < 2.3)<br /><br />FLOOR(-5.6) = -6.0 (-6 < -5.6)',
    copy: 'FLOOR(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'COS',
    title: 'COS(numeric_column)',
    content: 'Return the cosine of an angle, which is specified in radians.',
    example: 'COS(1) = 0.5403',
    copy: 'COS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ACOS',
    title: 'ACOS(numeric_column)',
    content: 'Return the arccosine of a number. The result is in radians.',
    example: 'ACOS(1) = 0',
    copy: 'ACOS(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'SIN',
    title: 'SIN(numeric_column)',
    content: 'Return the sine of an angle, which is specified in radians.',
    example: 'SIN(1) = 0.8415',
    copy: 'SIN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ASIN',
    title: 'ASIN(numeric_column)',
    content: 'Return the arcsine of a number. The result is in radians.',
    example: 'ASIN(1) =1.5708',
    copy: 'ASIN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'TAN',
    title: 'TAN(numeric_column)',
    content: 'Return the tangent of an angle, which is specified in radians.',
    example: 'TAN(1) = 1.5574',
    copy: 'TAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ATAN',
    title: 'ATAN(numeric_column)',
    content: 'Return the arctangent of a number. The result is in radians.',
    example: 'ATAN(1) = 0.7854',
    copy: 'ATAN(numeric_column)'
  },
  {
    type: ['all', 'integer', 'float'],
    titleDisplay: 'ATAN2',
    title: 'ATAN2(numeric_column1, numeric_column2)',
    content: 'Return the arctangent of two given columns. The result is in radians.',
    example: 'ATAN2(3,4) = 0.6435',
    copy: 'ATAN2(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'CASE',
    title: 'CASE \n      WHEN <condition1> THEN <return1>\n      [...]\n      [ELSE <else>] \nEND',
    content:
      'Find values that matche <condtion> and returns the corresponding <return> value. <condtion> must be a boolean expression (ex: age>20)',
    example:
      'CASE WHEN age < 20 THEN "teenager"<br />           WHEN age < 60 THEN "adult"<br />           ELSE "elder adult" <br />END',
    copy: 'CASE \n      WHEN <condition1> THEN <return1>\n      [...]\n      [ELSE <else>] \nEND'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'IF',
    title: 'IF(condition_expression, true_result, else_result)',
    content:
      'Check whether a value meets a condition and assign it to different values. If TRUE, it returns true_value. Otherwise, it returns else_value.',
    example: 'IF(age > 20, "adult", "nonadult")<br />IF(close_price > open_price, "higher", "lower")',
    copy: 'IF(condition_expression, true_result, else_result)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'IFNULL',
    title: 'IFNULL(column, null_replacement)',
    content:
      'Check whether a value is NULL. If the value is not null, it returns the original value. Otherwise, it returns null_replacement.',
    example: 'IFNULL(NULL, -1) = -1<br />IFNULL(profit, 0)',
    copy: 'IFNULL(column, null_replacement)'
  },
  {
    type: ['all', 'condition'],
    titleDisplay: 'NULLIF',
    title: 'NULLIF(column1, column2)',
    content: 'Check whether value1 is equal to value2. Returns NULL if TRUE, otherwise returns the value1.',
    example: 'NULLIF(0, 0) = NULL<br />NULLIF(10, 0) = 10',
    copy: 'NULLIF(column1, column2)'
  },
  {
    type: ['all', 'popular', 'others'],
    titleDisplay: 'ROW_NUMBER',
    title: 'ROW_NUMBER() OVER([PARTITION BY column1] [ORDER BY column2])',
    content:
      'Assign a sequential integer to each row as a row number. The row number starts from 1. If <column1>  is specified, the function will group data based on column1 and assign numbers for each group separately. If <column2> is specified, the function will sort data based on the column first and then assign a row number for each row.',
    example: 'row_number = ROW_NUMBER() OVER()',
    copy: 'ROW_NUMBER() OVER([PARTITION BY column1] [ORDER BY column2])'
  },
  {
    type: ['all', 'popular', 'others'],
    titleDisplay: 'LAG',
    title: 'LAG(column1, [n_lags]) OVER([PARTITION BY column2] ORDER BY column3)',
    content:
      'Move each value in <column1> forward to the next row. The table will be ordered by <column3> first before values are moved. If n_lags is specified, each value is shifted to the next n_lags rows. The first n_lags values will be NULL. If <column2>  is specified, the function will group data based on <column2> and move values for each group separately.',
    example: 'price_lag = LAG(price) OVER(ORDER BY date)',
    copy: 'LAG(column1, [n_lags]) OVER([PARTITION BY column2] ORDER BY column3)'
  },
  {
    type: ['all', 'type conversion'],
    titleDisplay: 'CAST',
    title: 'CAST(column AS typename)',
    content:
      'Convert the value to the other data type. CAST() may fail if some value cannot be converted to the specified type.<br /><br />The type name can be STRING, BOOL, FLOAT64, INT64, NUMERIC, DATE, DATETIME, TIME, TIMESTAMP.',
    example:
      'CAST(123 AS STRING)\r<br />Result: "123"\r<br />\r<br />CAST("apple" AS INT64)\r<br />Result: raising an error',
    copy: 'CAST(column AS typename)'
  },
  {
    type: ['all', 'type conversion'],
    titleDisplay: 'SAFE_CAST',
    title: 'SAFE_CAST(column AS typename)',
    content:
      'Convert the value to the other data type. SAFE_CAST() is identical to CAST(), but it never fails. It returns NULL when facing an error. <br /><br />The type name can be STRING, BOOL, FLOAT64, INT64, NUMERIC, DATE, DATETIME, TIME, TIMESTAMP.',
    example: 'SAFE_CAST(123 AS STRING)<br />Result: "123"<br /><br />SAFE_CAST("apple" AS INT64)<br />Result: null',
    copy: 'SAFE_CAST(column AS typename)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'AVG',
    title: 'AVG(numeric_column)',
    content: 'Return the average of all the values in the given column. Null values are ignored.',
    example: 'SELECT AVG(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'AVG(numeric_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'COUNT',
    title: 'COUNT(*)',
    content: 'Return the number of rows in the table, including null values.',
    example: 'SELECT COUNT(*) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'COUNT(*)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'COUNT(DISTINCT)',
    title: 'COUNT(DISTINCT column)',
    content:
      'Return the number of unique values in the given column. Null values are not counted. Each unique value is counted only once.',
    example: 'SELECT COUNT(DISTINCT state_name) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'COUNT(DISTINCT column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'COUNTIF',
    title: 'COUNTIF(condition_expression)',
    content: 'Return the number of rows that meet the condition.',
    example: 'SELECT COUNTIF(confirmed_cases > 1000) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'COUNTIF(condition_expression)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'MAX',
    title: 'MAX(numeric_column)',
    content: 'Return the maximum value in the given column.',
    example: 'SELECT MAX(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'MAX(numeric_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'MIN',
    title: 'MIN(numeric_column)',
    content: 'Return the minimum value in the given column.',
    example: 'SELECT MIN(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'MIN(numeric_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'STRING_AGG',
    title: 'STRING_AGG(string_column)',
    content: 'Return a value that is obtained by concatenating all strings with commas.',
    example: 'SELECT STRING_AGG(state_name) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'STRING_AGG(string_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'SUM',
    title: 'SUM(numeric_column)',
    content: 'Return the sum of all the values in the given column. Null values are ignored.',
    example: 'SELECT SUM(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'SUM(numeric_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'CORR',
    title: 'CORR(numeric_column1, numeric_column2)',
    content: 'Return the Pearson correlation coefficient between two columns.',
    example: 'SELECT CORR(confirmed_cases, deaths) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'CORR(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'COVAR_POP',
    title: 'COVAR_POP(numeric_column1, numeric_column2)',
    content: 'Return the population covariance between two columns.',
    example: 'SELECT COVAR_POP(confirmed_cases, deaths) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'COVAR_POP(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'COVAR_SAMP',
    title: 'COVAR_SAMP(numeric_column1, numeric_column2)',
    content: 'Return the sample covariance between two columns.',
    example: 'SELECT COVAR_SAMP(confirmed_cases, deaths) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'COVAR_SAMP(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'STDDEV_POP',
    title: 'STDDEV_POP(numeric_column1, numeric_column2)',
    content: 'Return the population (biased) standard deviation of the values in the given column.',
    example: 'SELECT STDDEV_POP(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'STDDEV_POP(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'STDDEV_SAMP',
    title: 'STDDEV_SAMP(numeric_column1, numeric_column2)',
    content: 'Return the sample (unbiased) standard deviation of the values in the given column.',
    example: 'SELECT STDDEV_SAMP(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'STDDEV_SAMP(numeric_column1, numeric_column2)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'VAR_POP',
    title: 'VAR_POP(numeric_column)',
    content: 'Return the population (biased) variance of the values in the given column.',
    example: 'SELECT VAR_POP(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'VAR_POP(numeric_column)'
  },
  {
    type: ['all', 'aggregation'],
    titleDisplay: 'VAR_SAMP',
    title: 'VAR_SAMP(numeric_column)',
    content: 'Return the sample (unbiased) variance of the values in the given column.',
    example: 'SELECT VAR_SAMP(confirmed_cases) FROM SQL_EDITOR_us_states_TABLE;',
    copy: 'VAR_SAMP(numeric_column)'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_TO_STRING',
    title: 'ARRAY_TO_STRING(array_column, [delimiter], [null_text])',
    content:
      'Convert the array column into the string column. The delimiter by default is a comma. If null_text is specified, all NULL values in the array will be replaced by the null_text.',
    example:
      'ARRAY_TO_STRING(["coffee", "tea", "milk"])<br />Result: "coffee, tea, milk"<br /><br />ARRAY_TO_STRING(["coffee", "tea", NULL], "--", "missing")<br />Result: "coffee--tea--missing"',
    copy: 'ARRAY_TO_STRING(array_column, [delimiter], [null_text])'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_LENGTH',
    title: 'ARRAY_LENGTH(array_column)',
    content:
      'Return the number of the elements in the array. 0 represents an empty array and NULL if the array_expression is NULL.',
    example: 'ARRAY_LENGTH(["coffee", "tea", "milk"])<br />Result: 3',
    copy: 'ARRAY_LENGTH(array_column)'
  },
  {
    type: ['all', 'array'],
    titleDisplay: 'ARRAY_REVERSE',
    title: 'ARRAY_REVERSE(array_column)',
    content: 'Reverse the array in reverse order.',
    example: 'ARRAY_REVERSE(["coffee", "tea", "milk"])\r<br />Result: ["milk", "tea", "coffee"]',
    copy: 'ARRAY_REVERSE(array_column)'
  }
];
